// user.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, RequestOptionsArgs, Headers } from '@angular/http';
import { HttpHelper } from '../shared/http-helper';
import { Observable } from 'rxjs/Rx';
import { AppConfigValues } from '../shared/app-config-values';
import * as _ from 'lodash';

@Injectable()
export class UserInfoService {
  
  constructor(private httpHelper: HttpHelper) {}

  isScenarioOwner(userId: number, scenarioId: number): Observable<any> {
        return this.httpHelper.get(`api/user-info/scenario-owner/${userId}/${scenarioId}`);
  }

  public getRegCode(userId: number): Observable<any> {
        return this.httpHelper.get(`api/user-info/reg-code/${userId}`);
  }

  public getRegionalYear(userId: number): Observable<any>{
        return this.httpHelper.get(`api/user-info/regional-years/${userId}`);
  }
}


/** WEBPACK FOOTER **
 ** ./app/shared/user-info.service.ts
 **/